import axios from "axios";

const API_URL = "https://translation.digitalmoitech.com/translate";
const pending = new Map();

// The global typing helper and dropdowns often request the same word together.
// Share that request while allowing the translator to finish, even when slow.
// Callers retain their existing cache/fallback.
export function requestTranslation(payload, config = {}) {
  const key = JSON.stringify(payload);
  if (pending.has(key)) return pending.get(key);

  const request = axios.post(API_URL, payload, {
    ...config,
    timeout: 0,
  }).finally(() => {
    pending.delete(key);
  });
  pending.set(key, request);
  return request;
}
